module.exports = __webpack_public_path__ + "img/checked_bgGreen.bfafebd2.svg";